import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const LearnIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" title={t`Learn`} {...props}>
    <Path
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 13 2 9l10-4 10 4-10 4ZM7 14v3s2.897 2 5 2 5-2 5-2v-3M20 10v4"
    />
  </Icon>
);
